const AUTH_EXCLUDED_PATHS = new Set(['/login', '/auth/redirect/login']);

export const setRedirectAfterLogin = (path: string) => {
    if (!path.startsWith('/')) {
        return;
    }

    const [pathname] = path.split('?');
    if (!pathname || pathname === '/' || AUTH_EXCLUDED_PATHS.has(pathname)) {
        return;
    }

    localStorage.setItem('redirectAfterLogin', path);
};

export const consumeRedirectAfterLogin = () => {
    const path = localStorage.getItem('redirectAfterLogin');
    localStorage.removeItem('redirectAfterLogin');
    return path;
};

export const getRedirectAfterLogin = () => localStorage.getItem('redirectAfterLogin');

export type SortOrder = -1 | 1;

export type SortState<TColumn> = {
    columnName: TColumn;
    columnOrder: SortOrder;
};

export type DateRange = [Date, Date];

export const cloneDateRange = (value: DateRange): DateRange => [
    new Date(value[0]),
    new Date(value[1]),
];
